import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/showToaster";
import { UserRoleFormValues } from "src/models/UserRole.model";
import { useAddUserRoleMutation } from "src/services/UserRoleService";
import UserRoleForm from "../Layouts/UserRoleForm";

type Props = {
  onClose: () => void;
};

const AddUserRoleWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const initialValues: UserRoleFormValues = {
    roleName: "",
    module: [], // Initialize with empty array
  };

  // Validation Schema
  const validationSchema = object().shape({
    roleName: string().required("Please enter UserRole name"),
  });

  const [addUserRole] = useAddUserRoleMutation();

  // Handle Submit
  const handleSubmit = (
    values: UserRoleFormValues,
    { setSubmitting, resetForm }: FormikHelpers<UserRoleFormValues>
  ) => {
    const modules = values.module.map((module) => ({
      moduleId: module.moduleId,
      moduleName: module.moduleName,
      moduleAction: module.moduleAction.map((action) => ({
        actionId: action.actionId,
        actionName: action.actionName,
        actionUrl: action.actionUrl,
        // fields: action.fields,
      })),
    }));

    const payload = {
      roleName: values.roleName,
      module: modules,
    };

    addUserRole(payload).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="md" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <UserRoleForm
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddUserRoleWrapper;
